import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../assets/images/Logo.png';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import '../styles/Navbar.css';

const Navbar = ({ openAuth }) => {
  const { lang, toggleLang, translations } = useLanguage();
  const { user, logout } = useAuth();
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsAtTop(scrollTop < 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      className="navbar"
      initial={{ y: -100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        scale: isAtTop ? 1.02 : 1,
        height: isAtTop ? '75px' : '70px'
      }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <motion.div
        className="logo-section"
        initial={{ x: -50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <motion.button
          className="lang-toggle-mobile"
          onClick={toggleLang}
          whileHover={{ scale: 1.05, backgroundColor: "var(--border)" }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 400 }}
        >
          {lang === 'en' ? 'عربي' : 'English'}
        </motion.button>

        <motion.div
          className="logo"
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <motion.img
            src={logo}
            alt="Logo"
            width="40"
            whileHover={{ scale: 1.1, rotate: 5 }}
            transition={{ type: "spring", stiffness: 300 }}
          />
          <span> {translations.nav.name} </span>
        </motion.div>

        {user ? (
          <motion.button
            className="logout-btn-mobile"
            onClick={logout}
            whileHover={{ scale: 1.05, backgroundColor: "#dc2626" }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            {translations.admin.logout}
          </motion.button>
        ) : (
          <motion.button
            className="login-btn-mobile"
            onClick={openAuth}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            {translations.auth.login}
          </motion.button>
        )}
      </motion.div>

      <motion.ul
        className="nav-links"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        <motion.li
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400 }}
        >
          <Link to="/">{translations.nav.home}</Link>
        </motion.li>
        <motion.li
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400 }}
        >
          <Link to="/about">{translations.nav.about}</Link>
        </motion.li>
        <motion.li
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400 }}
        >
          <Link to="/designs">{translations.nav.designs}</Link>
        </motion.li>
      </motion.ul>

      <motion.div
        className="right"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        {user ? (
          <motion.button
            className="logout-btn"
            onClick={logout}
            whileHover={{ scale: 1.05, backgroundColor: "#dc2626" }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            {translations.admin.logout}
          </motion.button>
        ) : (
          <motion.button
            className="login-btn"
            onClick={openAuth}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            {translations.auth.login}
          </motion.button>
        )}
        <motion.button
          className="lang-toggle"
          onClick={toggleLang}
          whileHover={{ scale: 1.05, backgroundColor: "var(--border)" }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 400 }}
        >
          {lang === 'en' ? 'عربي' : 'English'}
        </motion.button>
      </motion.div>
    </motion.nav>
  );
};

export default Navbar;
